<section class="mt-5">
  <h2 class="h4">Find a User</h2>
  <p-messages key="userStatusMsg" [closable]="true"></p-messages>
  <form (ngSubmit)="onSubmit(userForm)" #userForm="ngForm" class="row row-cols-lg-auto g-3">
    <div class="col-12">
      <div class="row g-3">
        <div class="col-auto"><label for="userEmail" class="col-form-label">User email:</label></div>
        <div class="col-auto">
          <p-autoComplete #email [(ngModel)]="selectedUser" name="Email" inputId="userEmail" field="Email" #Email="ngModel" dataKey="Id" [suggestions]="filteredUsers" (completeMethod)="searchUsers($event)" (onDropdownClick)="searchUsers($event)" [forceSelection]="true" [dropdown]="true" [showEmptyMessage]="true" emptyMessage="No matching users found." placeholder="User email" [tabindex]="0" ariaLabelledBy="ac-desc"></p-autoComplete>
          <span id="ac-desc" class="visually-hidden">Begin typing a user email to see list of matching user suggestions.</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div id="EnableDisableUserGroupLegend" class="visually-hidden">Enable or Disable Selected User</div>
      <div class="row g-3">
        <div class="col-auto">
          <div class="form-check mt-2">
            <input aria-label="Enable selected user" id="enableChbx" class="form-check-input" type="radio" name="Disabled" value="false" [(ngModel)]="selectedValue">
            <label class="form-check-label" for="enableChbx"> Enable</label>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-check mt-2">
            <input aria-label="Disable selected user" id="disableChbx" class="form-check-input" type="radio" name="Disabled" value="true" [(ngModel)]="selectedValue" />
            <label class="form-check-label" for="disableChbx"> Disable</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <button type="submit" [disabled]="!email.value || !selectedValue" class="btn btn-active mx-3">Save</button>
      <button type="reset" class="btn btn-secondary">Cancel</button>
    </div>
  </form>
</section>
